import { deserialize, serialize } from "cerialize";
import EntityAware from "../EntityAware";

export default class TUKGrowthMetricItem implements EntityAware {
    @serialize
    @deserialize
    public total: number = 0;

    @serialize
    @deserialize
    public percentage_change: number = 0;
}
